import React from 'react';
import PropTypes from 'prop-types';

import { LinkWrap, Image, TextWrap, Name, Features } from './styles';

const Card = ({ className, linkTo, imageUrl, name, features, handleClick }) => (
    <LinkWrap className={className} to={linkTo} onClick={handleClick} type="catalog-link">
        <Image
            src={imageUrl}
            imgUrls={imageUrl}
            sizes={{
                default: '100%',
            }}
        />
        <TextWrap>
            <Name>{name}</Name>
            <Features>{features}</Features>
        </TextWrap>
    </LinkWrap>
);

Card.propTypes = {
    className: PropTypes.string,
    linkTo: PropTypes.string.isRequired,
    imageUrl: PropTypes.oneOfType([PropTypes.array, PropTypes.string]).isRequired,
    name: PropTypes.string.isRequired,
    features: PropTypes.string,
    handleClick: PropTypes.func,
};

Card.defaultProps = {
    className: '',
    features: '',
    handleClick: () => {},
};

export default Card;
